const { trackGoal } = require('./trackGoal.js')

const searchToggle  = document.querySelector('.toggle-search')
const searchOverlay = document.querySelector('.search-overlay')
const searchInput   = searchOverlay.querySelector('input')
let isSearchOpen  = false

searchToggle.addEventListener('click', () => {
  if (isSearchOpen) {
    closeSearch()
  } else {
    openSearch()
  }
})

const closeSearch = () => {
  document.body.classList.remove('has-search-open')
  searchToggle.classList.remove('is-open')

  isSearchOpen = false
}

const openSearch = () => {
  document.body.classList.add('has-search-open')
  searchToggle.classList.add('is-open')
  searchInput.focus()

  isSearchOpen = true

  trackGoal(2)
}


// WEBPACK FOOTER //
// ./source/js/components/search.js